<template>
  <!-- 维修耗材 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="工单号">
              <a-input v-model="query.workNo" placeholder="请输入工单号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="材料名称">
              <a-input v-model="query.materialName" placeholder="请输入材料名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="领取人">
              <a-input v-model="query.recipients" placeholder="请输入领取人" allow-clear />
            </a-form-item>
          </a-col>
<!--          <a-col :md="6" :sm="12">-->
<!--            <a-form-item label="登记人">-->
<!--              <a-input v-model="query.registerPerson" placeholder="请输入登记人" allow-clear />-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :md="12" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
        <!-- <a-row :gutter="48">

        </a-row>-->
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a @click="PatrolAdd(record.id)" v-action:edit>编辑</a>
        <a-divider type="vertical" /> -->
        <a @click="goDetails(record)">详情</a>
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>

      <span slot="approveStatus" slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1"  color="rgb(50, 205, 50)">审批通过</a-tag>
        <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
      </span>
    </a-table>

    <counsumable-modal ref="PatrolModal" @handleOk="queryList"></counsumable-modal>
    <a-modal title="查看" :visible="showTubeV" :width="700" destroyOnClose @cancel="closeTube">
      <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
      <template slot="footer">
        <a-button @click="closeTube">取消</a-button>
      </template>
      <a-row style="margin-top: 20px">
        <a-col :span="12">材料编码：{{ details.materialsNo }}</a-col>
        <a-col :span="12">材料名称：{{ details.materialName }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">工单号：{{ details.workNo }}</a-col>
        <a-col :span="12">材料规格：{{ details.materialType }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">单位：{{ details.unit }}</a-col>
        <a-col :span="12"
          >审批状态：
          <a-tag v-if="details.approveStatus === 0" color="#f50">待审批</a-tag>
          <a-tag v-if="details.approveStatus === 1"  color="#32CD32">审批通过</a-tag>
          <a-tag v-if="details.approveStatus === 2" color="green">审批不通过</a-tag>
          </a-col
        >
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">数量(个)：{{ details.count }}</a-col>
        <a-col :span="12">领取人：{{ details.recipients }}</a-col>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col :span="12">领取时间：{{ details.receiveTime }}</a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import CounsumableModal from './modules/CounsumableModal'
// import OrderModal from './modules/OrderModal'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '工单号',
    dataIndex: 'workNo',
  },
  {
    title: '材料编码',
    dataIndex: 'materialsNo',
  },
  {
    title: '材料名称',
    dataIndex: 'materialName',
  },
  {
    title: '材料规格',
    dataIndex: 'materialType',
  },
  {
    title: '数量',
    dataIndex: 'count',
  },
  {
    title: '单位',
    dataIndex: 'unit',
  },
  {
    title: '审批状态',
    dataIndex: 'approveStatus',
    scopedSlots: { customRender: 'approveStatus' },
  },
  {
    title: '领取人',
    dataIndex: 'recipients',
  },
  {
    title: '领取时间',
    dataIndex: 'receiveTime',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    CounsumableModal,
  },
  name: 'PatrolManagement',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/maintenance_consumables/page',
      deleteUrl: '/pipe-network/maintenance_consumables',
      addOrUpdateUrl: '/pipe-network/inspection_managements',
      queryOneUrl: '/pipe-network/inspection_managements',
      exportDataUrl: 'pipe-network/maintenance_consumables/export',
      exportFileName: '维修耗材表.xlsx',
      query: {
        workOrderType: '',
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        sysType: '巡检',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      details: {},
      showTubeV: false,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
      },
    }
  },
  filters: {},
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    goDetails(record) {
      this.details = record
      this.showTubeV = true
    },
    closeTube() {
      this.showTubeV = false
    },
    PatrolAdd(id) {
      this.$refs.PatrolModal.edit(id)
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
